import {PropertyType} from 'src/types/property'
import CustomIconSvg from 'src/components/elements/icons/svgs/CustomIconSvg'
import clsx from 'clsx'
import {useCurrentLocale} from 'src/hooks/locale'
import {LOCALE_FR} from 'src/constants/locale'
import {formatNumber, getCurrencySymbol} from 'src/utils/other'
import AppTypography from 'src/components/elements/typography/AppTypography'
import {dayjs} from 'src/utils/date'
import {useTranslation} from 'next-i18next'

export default function PropertyPromotionContent(props: {
  property: PropertyType
  className?: string
}) {
  const {property, className} = props
  const locale = useCurrentLocale()
  const {t} = useTranslation('common')
  const promo = property.promo || null
  const currency = getCurrencySymbol(property.basic_pricing?.currency)

  if (!promo) {
    return null
  }

  if (!promo.promo_content_en && !promo.promo_content_fr) {
    return null
  }

  const totalAmounts = promo.promo_amount_in_cents
    ? formatNumber(promo.promo_amount_in_cents / 100)
    : null
  const content =
    locale === LOCALE_FR
      ? promo.promo_content_fr
      : promo.promo_content_en
      ? promo.promo_content_en
      : promo.promo_content_fr

  const startDate = promo.promo_start ? dayjs(promo.promo_start) : null
  const endDate = promo.promo_end ? dayjs(promo.promo_end) : null

  if (!content) {
    return null
  }

  const dates = []
  if (startDate) {
    dates.push(startDate.format('D MMMM YYYY'))
  }
  if (endDate) {
    dates.push(endDate.format('D MMMM YYYY'))
  }
  const finalDate = dates.join(` ${t('to')} `)

  return (
    <div
      className={clsx(
        ' border border-gray-200 rounded-xl overflow-hidden',
        className,
      )}
    >
      <div className="w-full flex flex-row justify-center items-stretch">
        <div className="bg-gray-200 flex flex-col justify-center items-center px-6">
          <CustomIconSvg
            icon="promo"
            className="text-gray-800 min-w-6 w-6 h-6"
          />
        </div>
        <div className="flex-1 flex flex-col justify-start items-start px-6 py-2">
          <AppTypography
            variant="displaySmall"
            className="font-black text-gray-800"
          >
            {currency}
            {totalAmounts}
          </AppTypography>
          <AppTypography variant="captionSlim" className="text-gray-800">
            {content}
          </AppTypography>
          {finalDate && (
            <AppTypography variant="captionSlim" className="text-gray-800 pt-2">
              {finalDate}
            </AppTypography>
          )}
        </div>
      </div>
    </div>
  )
}
